export default {
    data: function () {
        return {}
    },
    computed:
        {},
    created: function () {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
        axios.defaults.headers.post['Accept'] = 'application/json';
    },
    methods: {}
};